import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import $ from "jquery";
import { Link } from 'react-router-dom';




export default function Search() {

    const [searched, getSearched] = useState(null);
    const [searchResult, getSearchResult] = useState(null);
    const [allGenres,setGenres] = useState(null);
    const [categorySelect, setCategorySelect] = useState("none")
    const [categoryResult, setCategoryResult] = useState(null)

    
    async function selectedCategory(e){
        console.log(e.target.value);
        setCategorySelect(e.target.value)
    }


    async function getTopRatedMovies(){
        let {data} = await axios.get(`https://api.themoviedb.org/3/discover/movie?api_key=0ada3fcaa2e394ff1ad6ed7e6c5db6c5&language=en-US&region=us&sort_by=vote_average.desc&include_adult=false&with_runtime.gte=100&include_video=false&page=1&vote_average.lte=8.8&with_genres=${categorySelect}&with_watch_monetization_types=flatrate`);
        setCategoryResult(data.results)
        console.log(data.results);
    }

    async function getCategory() {
        let {data} = await axios.get(`https://api.themoviedb.org/3/genre/movie/list?api_key=0ada3fcaa2e394ff1ad6ed7e6c5db6c5&language=en-US`)
        setGenres(data.genres)
    }

    
  

    async function getsearched() {
        let { data } = await axios.get(`https://api.themoviedb.org/3/search/multi?api_key=0ada3fcaa2e394ff1ad6ed7e6c5db6c5&language=en-US&query=${searched}&page=1&include_adult=false`)
        getSearchResult(data.results)//.map((elem) => elem.original_title != undefined? elem.original_title:""));
    }

    

    function getSearchValue() {
        let searchValue = $('#search')[0].value;
        if (searchValue != null) {
            getSearched(searchValue)
        }
    }

    useEffect(() => {
        getsearched();
        getCategory()
        getTopRatedMovies()
    }, [searched,categorySelect])
    

    return <>
   <div className='container'>
   <input onChange={getSearchValue} autoComplete="off" className='form-control bg-light text-dark my-3' type="text" id="search" placeholder='Search for Movie,Series' />
   <select className="form-select mb-3" aria-label="Default select example" onChange={selectedCategory}>
   <option value={"none"}>---</option>
    {allGenres != null && allGenres.map((elem,idx) => 
        <option value={elem.id} onChange={selectedCategory} key={idx}>{elem.name}</option>
)}
</select>
            <div className="row">
                {searched != null ? <>{(searchResult.filter(elem =>  elem.media_type != "person" && elem.genre_ids.includes(99) == false && elem.poster_path != null )).map((elem, idx) => elem.media_type == "movie"? elem.title.includes("Porn") == false && elem.title.includes("Sex") == false && elem.title.includes("Gay") == false && elem.title.includes("Lesbian") == false && elem.title.includes("Anal") == false && elem.title.includes("Boobs") == false && elem.title.includes("Horny") == false ? <div key={idx} className='col-md-2'>
                    <Link to={`/moviedetails/${elem.id}`}>
                        <div className="movie imghov position-relative">
                            <img className='rounded-3 w-100' src={`https://image.tmdb.org/t/p/w500/${elem.poster_path}`} alt="moviepic" />
                            <h6 className='rating p-2 rounded-circle'>{(elem.vote_average)}</h6>
                            <h6 className='mt-2'>{elem.title}</h6>
                        </div>
                    </Link>
                </div>:" ": elem.name.includes('Porn') == false && elem.name.includes('Sex') == false && elem.name.includes("Gay") == false && elem.name.includes("Lesbian") == false? <div key={idx} className='col-md-2'> {console.log(elem.name)}{console.log(elem.name.includes('Porn'))}
                    <Link to={`/seriesdetails/${elem.id}`}>
                        <div className="series imghov position-relative">
                            <img className='w-100 rounded-3' src={"https://image.tmdb.org/t/p/w500/" + elem.poster_path} alt="seriespic" />
                            <h6 className='rating p-2 rounded-circle'>{(elem.vote_average)}</h6>
                            <h6 className='mt-3'>{elem.name}</h6>
                        </div>
                    </Link>
                </div>:""
    )}</> : ''}
            {categoryResult != null && categorySelect != "none"? <>
            {categoryResult.map((elem,idx) => <div className='col-md-2' key={idx}>
            <Link to={`/moviedetails/${elem.id}`}>
                        <div className="movie imghov position-relative">
                            <img className='rounded-3 w-100' src={`https://image.tmdb.org/t/p/w500/${elem.poster_path}`} alt="moviepic" />
                            <h6 className='rating p-2 rounded-circle'>{(elem.vote_average)}</h6>
                            <h6 className='mt-2'>{elem.title}</h6>
                        </div>
                    </Link>
            </div>)}
            </>: ""}
            </div>
    </div>
    
    
    
    </>
}
